module.exports = __webpack_public_path__ + "static/media/5.833ef8d3.jpg";